import { Injectable } from '@angular/core';
import { PageName } from 'src/app/core/enums';
import { ErrorObj } from 'src/app/core/models';
import { ErrorService } from 'src/app/core/services/error.service';
import { UserService } from 'src/app/core/user/user.service';
import { RoutingService } from './routing.service';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Injectable()
export class RegisterService {

  constructor(
    private routingService: RoutingService,
    private userService: UserService,
    private errorService: ErrorService,
    private previousRouteService : PreviousRouteService,
    private navigationService: NavigationService
  ) { }

  async otpSignUp(signupForm: any) {
    return await this.userService.signup({ ...signupForm });
  }

  onSignupSuccess() {
    let previousRoute = this.previousRouteService.getPreviousRoute();
    localStorage.removeItem('previousRoute');
    this.navigationService.navigateByUrl(previousRoute.routeName);
  }

  setError(errorObj: ErrorObj) {
    this.errorService.insertErrorObj(errorObj);
    this.userService.error(errorObj);
  }

  navigateToPage(pageName: PageName) {
    const rtSv = this.routingService;
    rtSv.navigate(pageName);
  }
}
